import { render, staticRenderFns } from "./LockProductDialog.vue?vue&type=template&id=2206e439&scoped=true&"
import script from "./LockProductDialog.vue?vue&type=script&lang=js&"
export * from "./LockProductDialog.vue?vue&type=script&lang=js&"
import style0 from "./LockProductDialog.vue?vue&type=style&index=0&id=2206e439&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2206e439",
  null
  
)

export default component.exports